<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="
              $l('merchant_function_form_language_funcName') || '功能名称'
            "
            prop="funcID"
          >
            <dict-select
              v-model="formData.funcID"
              url="/sys/merchant/function/form/language/dictSelect"
              style="width:100%"
              size="small"
              clearable
              filterable
              :disabled="isEdit"
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item
            :label="$l('merchant_function_form_language_labelKey') || '关键字'"
            prop="labelKey"
          >
            <el-input
              v-model="formData.labelKey"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              :disabled="isEdit"
              clearable
              maxlength="50"
              class="input-with-select"
            >
              <el-select
                v-if="disabled ? false : !isEdit"
                v-model="formData.labelType"
                :disabled="isEdit"
                filterable
                clearable
                slot="prepend"
                :placeholder="'请选择功能类型'"
              >
                <el-option value="form_label_" label="表单文本(form_label)" />
                <el-option
                  value="form_placeholder_"
                  label="表单占位符(form_placeholder)"
                />
                <el-option value="table_label_" label="表格标题(table_label)" />
                <el-option value="tips_" label="消息提示(tips)" />
                <el-option value="btn_" label="按钮(btn)" />
                <el-option
                  value="dialog_title_"
                  label="对话框标题(dialog_title)"
                />
              </el-select>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('merchant_function_form_language_cn_text') || '中文'"
            prop="cn_text"
          >
            <el-input
              v-model="formData.cn_text"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              maxlength="100"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('merchant_function_form_language_en_text') || '英文'"
            prop="en_text"
          >
            <el-input
              clearable
              v-model="formData.en_text"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="100"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    isEdit: { type: Boolean, default: false },
    funcID: { type: String, default: '' },
    labelKey: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {
        labelKey: '',
        cn_text: '',
        en_text: '',
        jp_text: '',
      },
      rules: {
        funcID: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        labelKey: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        cn_text: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        en_text: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.isEdit) return

      this.$api
        .merchantFunctionFormLanguageDetailApi({
          funcID: this.funcID,
          labelKey: this.labelKey,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async saveContinue() {
      const result = await this.submitSave()
      console.log('saveContinue result >>', result)
      if (!result) return

      this.formData.labelKey = ''
      this.formData.cn_text = ''
      this.formData.en_text = ''
      this.formData.jp_text = ''

      this.$emit('reload')
    },
    async saveClose() {
      const result = await this.submitSave()
      console.log('saveClose result >>', result)
      if (!result) return
      this.close()
      this.$emit('reload')
    },
    async submitSave() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      this.loadingOpen()
      return await this.saveApi()
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return false
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          return true
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          return false
        })
    },
    async saveApi() {
      if (this.isEdit) {
        return await this.$api.merchantFunctionFormLanguageUpdateApi(
          this.formData
        )
      }
      return await this.$api.merchantFunctionFormLanguageAddApi(this.formData)
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .input-with-select .el-select .el-input {
  width: 220px;
}
::v-deep .input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style>
